/*!
    * @product/scmp-sdk 1.1.39-hotfix.1
    * built by undefined
  */
function i(...d){var n,a;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(a=n.dataLayer)!==null&&a!==void 0&&a.push)||window.dataLayer.push(arguments)}export{i as a};
//# sourceMappingURL=chunk-IFN5XQWA.js.map
